import React, { useState, useEffect } from 'react';
import { HeroSection } from '@/components/HeroSection';
import { LifeInsuranceInfographic } from '@/components/LifeInsuranceInfographic';
import { DifferentiationSection } from '@/components/DifferentiationSection';
import { QuestionnaireFlow } from '@/components/QuestionnaireFlow';
import { BenefitsSection } from '@/components/BenefitsSection';
import { TestimonialsSection } from '@/components/TestimonialsSection';
import { BlogPreview } from '@/components/BlogPreview';
import { LifeInsuranceStats } from '@/components/LifeInsuranceStats';
import { AIAssistantWidget } from '@/components/AIAssistantWidget';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useIsMobile } from '@/hooks/use-mobile';

const Index = () => {
  const [showQuoteFlow, setShowQuoteFlow] = useState(false);
  const [utmParams, setUtmParams] = useState<Record<string, string>>({});
  const isMobile = useIsMobile();

  // Capture UTM parameters on page load
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};
    
    // Common UTM parameters
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    utmKeys.forEach(key => {
      const value = urlParams.get(key);
      if (value) params[key] = value;
    });
    
    setUtmParams(params);
    
    // Store UTM params in localStorage for session tracking
    if (Object.keys(params).length > 0) {
      localStorage.setItem('safurra_utm_params', JSON.stringify(params));
    }
  }, []);

  const handleGetStarted = () => {
    setShowQuoteFlow(true);
  };

  const handleCloseQuoteFlow = () => {
    setShowQuoteFlow(false);
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Tracking Pixels Container - Add your tracking codes here */}
      <div style={{ display: 'none' }}>
        {/* Facebook Pixel */}
        {/* <img height="1" width="1" style={{ display: 'none' }} src="https://www.facebook.com/tr?id=YOUR_PIXEL_ID&ev=PageView&noscript=1" /> */}
        
        {/* Google Ads Conversion Tracking */}
        {/* <img height="1" width="1" style={{ display: 'none' }} src="https://googleads.g.doubleclick.net/pagead/viewthroughconversion/YOUR_CONVERSION_ID/?..." /> */}
      </div>

      {/* Header */}
      <Header />

      {/* Hero Section - Main CTA */}
      <HeroSection onGetStarted={handleGetStarted} />

      {/* Life Insurance Infographic */}
      <LifeInsuranceInfographic />

      {/* Differentiation Section */}
      <DifferentiationSection />


      {/* How It Works Section */}
      <BenefitsSection onFindMatch={handleGetStarted} />

      {/* Testimonials */}
      <TestimonialsSection />

      {/* Blog Preview - Hidden on Mobile */}
      {!isMobile && <BlogPreview />}

      {/* Footer */}
      <Footer />

      {/* Questionnaire Flow - Overlay */}
      <QuestionnaireFlow 
        isVisible={showQuoteFlow} 
        onClose={handleCloseQuoteFlow} 
      />

      {/* AI Assistant Widget */}
      <AIAssistantWidget pageContext="homepage" />

      {/* UTM Debug Info (remove in production) */}
      {Object.keys(utmParams).length > 0 && (
        <div className="fixed bottom-4 left-4 p-3 bg-accent/90 rounded-lg text-sm text-muted-foreground backdrop-blur-sm">
          Campaign tracking: {Object.keys(utmParams).join(', ')}
        </div>
      )}
    </div>
  );
};

export default Index;